import { apiClient } from '@src/services/http-common'
import { ImportParams } from '@src/types/import'
import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

const ONSITEPRESENCE_SCOPE = 'onsitepresence'
const IMPORT = 'import'

const keysFactory = {
  import: () => [ONSITEPRESENCE_SCOPE, IMPORT] as const,
}

export async function postImportCsvFile(params: ImportParams) {
  const formData = new FormData()
  formData.append('file', params.file)
  return await apiClient.post(`Imports/${params.importType}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function usePostImportCsvFile(): [
  UseMutateAsyncFunction<AxiosResponse<void>, Error, ImportParams, unknown>,
  boolean,
  boolean,
  Error | null,
] {
  const { mutateAsync, isPending, isSuccess, error } = useMutation({
    mutationFn: (params: ImportParams) => postImportCsvFile(params),
    mutationKey: keysFactory.import(),
    onError: (error) => {
      console.error('Error importing CSV file:', error)
    },
  })

  return [mutateAsync, isPending, isSuccess, error]
}
